import * as yup from 'yup';

export const AddMerchantStoreSchema = yup.object().shape({
  name: yup.string().required('Store name is required'),
  email: yup.string().email('Please enter a valid email').required('Email is required'),
  phone: yup.string().required('Phone number is required'),
  address: yup.string().required('Address is required'),
  isActive: yup.boolean()
});
